/*
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { LoginService } from './login.service';

@Component({
  template: `
    <div>{{ error }}</div>`,
})
export class OktaCallbackComponent implements OnInit {
  error: string;

  constructor(private okta: OktaAuthService, private loginService: LoginService, private router: Router) {
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.okta.handleAuthentication();
      this.loginService.login().subscribe(
        (response) => {
          const fromUri = this.okta.getFromUri();
          const url = new URL(fromUri);
          const pathName = url.pathname;
          this.router.navigate([pathName]);
        },
        (error) => {
        }
      );
    } catch (e) {
      this.error = e.toString();
    }
  }
}
